import React from 'react';
import AuthLayout from '../../components/AuthLayout/Container';
import Navbar from '../../components/NavBar2/Container';
import CustomInput from '../../components/Input/Container';
import Spinner from '../../components/Spinner';
import { ActionBtn, Label, ErrorMessageText, ErrorMessageDiv, LoaderDiv, LoaderText, LinkText, FieldGroup } from './styles';
import { IPresenterProps } from './types';
import COLORS from '../../utils/Colors';
const SignUpPresenter: React.FC<IPresenterProps> = ({
    formData,
    errors,
    loading,
    onChange,
    onSubmit,
    onEmailBlur,
    emailExists,
    checkingEmail
}) => {
    return (
        <>
            <Navbar isSearchBarHidden={true} />
            <AuthLayout title="Crear Cuenta">
            <FieldGroup>
                <Label htmlFor="name">Nombre Completo</Label>
                <CustomInput
                    inputType="text"
                    value={formData.name}
                    onChange={(e: any) => onChange(e, 'name')}
                    bgColor={COLORS.white}
                    disabled={loading}
                    showDeleteTextIcon={false}
                    deleteText={() => {}}
                    textColor={COLORS.black}
                    showError={!!errors.name}
                />
                <ErrorMessageDiv visible={!!errors.name}>
                    <ErrorMessageText>{errors.name}</ErrorMessageText>
                </ErrorMessageDiv>
            </FieldGroup>

            <FieldGroup>
                <Label htmlFor="email">Correo Electrónico</Label>
                <CustomInput
                    inputType="email"
                    value={formData.email}
                    onChange={(e: any) => onChange(e, 'email')}
                    onBlur={onEmailBlur}
                    bgColor={COLORS.white}
                    disabled={loading || checkingEmail}
                    showDeleteTextIcon={false}
                    deleteText={() => {}}
                    textColor={COLORS.black}
                    showError={!!errors.email || emailExists}
                />
                <ErrorMessageDiv visible={!!errors.email || emailExists}>
                    <ErrorMessageText>
                        {errors.email}
                        {emailExists && (
                            <>
                                {' '}
                                <a href="/login" style={{ color: COLORS.mainTeal, textDecoration: 'underline' }}>
                                    Ir a iniciar sesión
                                </a>
                            </>
                        )}
                    </ErrorMessageText>
                </ErrorMessageDiv>
            </FieldGroup>

            <FieldGroup>
                <Label htmlFor="password">Contraseña</Label>
                <CustomInput
                    inputType="password"
                    value={formData.password}
                    onChange={(e: any) => onChange(e, 'password')}
                    bgColor={COLORS.white}
                    disabled={loading}
                    showDeleteTextIcon={false}
                    deleteText={() => {}}
                    textColor={COLORS.black}
                    showError={!!errors.password}
                />
                <ErrorMessageDiv visible={!!errors.password}>
                    <ErrorMessageText>{errors.password}</ErrorMessageText>
                </ErrorMessageDiv>
            </FieldGroup>

            <FieldGroup>
                <Label htmlFor="confirmPassword">Confirmar Contraseña</Label>
                <CustomInput
                    inputType="password"
                    value={formData.confirmPassword}
                    onChange={(e: any) => onChange(e, 'confirmPassword')}
                    bgColor={COLORS.white}
                    disabled={loading}
                    showDeleteTextIcon={false}
                    deleteText={() => {}}
                    textColor={COLORS.black}
                    showError={!!errors.confirmPassword}
                />
                <ErrorMessageDiv visible={!!errors.confirmPassword}>
                    <ErrorMessageText>{errors.confirmPassword}</ErrorMessageText>
                </ErrorMessageDiv>
            </FieldGroup>

            {loading ? (
                <LoaderDiv>
                    <Spinner size={40} color="#000000" thickness={3} />
                    <LoaderText>Creando tu cuenta...</LoaderText>
                </LoaderDiv>
            ) : (
                <ActionBtn onClick={onSubmit} disabled={loading || emailExists || checkingEmail}>
                    {checkingEmail ? 'Verificando...' : 'Crear Cuenta'}
                </ActionBtn>
            )}

            {!loading && (
                <LinkText>
                    ¿Ya tienes cuenta?{' '}
                    <a href="/login">
                        Iniciar Sesión
                    </a>
                </LinkText>
            )}
        </AuthLayout>
        </>
    );
};

export default SignUpPresenter;